export const GlobalConstants = {
  HALO_WAYPOINT_USER_AGENT:
    "HaloWaypoint/2021112313511900 CFNetwork/1327.0.4 Darwin/21.2.0",
  HALO_PC_USER_AGENT: "SHIVA-2043073184/6.10021.18539.0 (release; PC)",
  DEFAULT_AUTH_SCOPES: ["Xboxlive.signin", "Xboxlive.offline_access"],
};
